<template>
  <div>
    <div class="userTeams" v-show="showTeams">
      <div class="content">
        <div
          v-for="(item, index) in items"
          :key="`${index}-${item.id}`"
          class="px-4 py-2"
        >
          <button
            @click="teamSelect(item)"
            class="btn btn-sm btn-light w-100 button-font-sm"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'
import JwtService from '@/core/services/jwt.service'

export default {
  name: 'UserTeams',
  data() {
    return {
      showTeams: false,
      showMap: false,
      items: [],
    }
  },
  created() {
    this.getItems()
  },
  mounted() {
    EventBus.$on(`teamSelect`, this.listenerteamSelect)
    EventBus.$on(`teamClose`, this.listenerteamClose)
    EventBus.$on(`changeVisibilityTeam`, this.listenerchangeVisibilityTeam)
  },
  beforeDestroy() {
    EventBus.$off(`teamSelect`, this.listenerteamSelect)
    EventBus.$off(`teamClose`, this.listenerteamClose)
    EventBus.$off(`changeVisibilityTeam`, this.listenerchangeVisibilityTeam)
  },
  methods: {
    listenerteamSelect(payload) {
      this.selectedTeam = payload
    },
    listenerteamClose(payload) {
      this.showTeams = false
    },
    listenerchangeVisibilityTeam(payload) {
      this.getItems()
      this.showTeams = payload
    },
    getItems() {
      ApiService.get(`teams`)
        .then((res) => {
          this.items = res.data.data
          EventBus.$emit('showTeamArea', this.items.length > 0)
        })
        .catch((err) => {
          EventBus.$emit('showTeamArea', false)
        })

      // setTimeout(() => {
      //   this.items = [
      //     { id: '111', name: 'Engineering Development' },
      //     { id: '222', name: 'Customer Project / Softtech' },
      //     { id: '333', name: 'Customer Project / BusinessDesk' },
      //   ]
      //   EventBus.$emit('showTeamArea', true)
      // }, 1000)
    },
    teamSelect(team) {
      JwtService.setUserTeam(team)
      EventBus.$emit('teamSelect', team.name)

      this.close()
      this.redirectAfterChange()
    },
    redirectAfterChange() {
      let current = this.$router.currentRoute.fullPath.split('/')
      if (current.length > 3) {
        this.$router.push(`/${current[1]}/${current[2]}`)
      } else {
        this.$router.go(0)
      }
    },
    close() {
      this.showTeams = false
      EventBus.$emit('teamClose')
    },
  },
}
</script>

<style lang="scss" scoped>
.userTeams {
  position: relative;
  z-index: 96;
  height: 0px;
  .content {
    position: absolute;
    margin-left: -100px;
    margin-top: 20px;
    min-width: 150px;
    padding: 0;
    background: #ffffff;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8a94a6;
  }
}
</style>
